module.exports = __webpack_public_path__ + "img/coca_logo1.0ca5e697.png";